const isCardsOnFileOperator = (roles) =>
  roles && roles.includes('cardsonfile-operator');

export default isCardsOnFileOperator;
